import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'

@Component({
  selector: 'app-registration-callback',
  template: `
    <flex-col-center-center style="width: 100vw; height: 100vh; background: white;">
      <div class="lds-dual-ring" style="width: 100px; height: 100px;"></div>
    </flex-col-center-center>
  `,
})
export class RegistrationCallbackComponent implements OnInit {
  constructor(public router: Router) {}

  ngOnInit(): void {
    void this.router.navigate(['/'])
  }
}
